import { motion } from "framer-motion";

interface YourBrandHereBadgeProps {
  isMobile: boolean;
}

export const YourBrandHereBadge = ({ isMobile }: YourBrandHereBadgeProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.4, ease: "easeOut", delay: 0.6 }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          // Desktop: avatar center ~71% from left. Place text to its right.
          // Mobile: no hero panel, avatar is centered at ~50%.
          top: isMobile ? "25%" : "30%",
          right: isMobile ? "8%" : "4%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {/* Big bold text */}
        <motion.div
          animate={{ opacity: [0.65, 1, 0.65] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          <span
            style={{
              fontSize: isMobile ? "22px" : "36px",
              fontWeight: 800,
              color: "#1E293B",
              lineHeight: 1.15,
              letterSpacing: "-0.02em",
              display: "block",
              whiteSpace: "nowrap",
            }}
          >
            Your Brand Here
          </span>
        </motion.div>

        {/* Arrow curving left and down toward the avatar */}
        <svg
          width={isMobile ? "120" : "180"}
          height={isMobile ? "120" : "180"}
          viewBox="0 0 180 180"
          fill="none"
          style={{ marginTop: "4px", overflow: "visible" }}
        >
          {/* Starts top-right, curves down and far left to reach avatar */}
          <path
            d="M140 8C100 8 40 25 -20 90C-40 115 -50 140 -45 160"
            stroke="#1E293B"
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
          {/* Arrowhead */}
          <path
            d="M-52 154L-45 162L-36 156"
            stroke="#1E293B"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </div>
    </motion.div>
  );
};
